import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import apiService from "../Utilities/APIService";
import {
  handleApiResponse,
  handleAxiosError,
} from "../components/Common/apiHelpers";

export function useMutations() {
  const [loading, setLoading] = useState({});
  const [error, setError] = useState({});

  const apiMutation = useMutation(
    async ({
      method = "post",
      endpoint,
      payload = null,
      params = null,
      config = {},
      alert,
    }) => {
      switch (method.toLowerCase()) {
        case "get":
          return apiService.get(endpoint, params, config, alert);
        case "post":
          return apiService.post(endpoint, payload, config, alert);
        case "put":
          return apiService.put(endpoint, payload, config, alert);
        case "delete":
          return apiService.delete(endpoint, params, config, alert);
        default:
          throw new Error(`Metoda ${method} nuk është e suportuar`);
      }
    }
  );

  const mutate = async (
    key,
    {
      method = "post",
      endpoint,
      payload = null,
      params = null,
      onSuccess,
      onError,
      alert,
      responseConfig = {},
      config = {},
    }
  ) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    setError((prev) => ({ ...prev, [key]: null }));

    try {
      const response = await apiMutation.mutateAsync({
        method,
        endpoint,
        payload,
        params,
        config,
        alert,
      });

      handleApiResponse(response, onSuccess, onError, responseConfig);

      return { data: response?.data, error: null };
    } catch (err) {
      setError((prev) => ({ ...prev, [key]: err }));
      handleAxiosError(err);
      if (onError) onError(err);
      return { data: null, error: err };
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  return { mutate, loading, error };
}
